export default ($t) => ({
  title: "TicketFreePrice",
  type: "object",
  expanded: true,
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
    amount_config: {
      title: $t("edit_campaign.schema_ticket_free_price_amount_config", "Amount configuration"),
      type: "list",
      default: [],
      expanded: true,
      items: {
        type: "object",
        properties: {
          from: {
            title: $t("edit_campaign.schema_ticket_free_price_amount_config_from", "From"),
            type: "number",
            description: $t(
              "edit_campaign.schema_ticket_free_price_amount_config_from_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
          to: {
            title: $t("edit_campaign.schema_ticket_free_price_amount_config_to", "To"),
            type: "number",
            description: $t("edit_campaign.schema_ticket_free_price_amount_config_to_description", {
              returnEmptyOnMissing: true,
            }),
          },
          tickets_qty: {
            title: $t(
              "edit_campaign.schema_ticket_free_price_amount_config_tickets_qty",
              "Tickets quantity"
            ),
            type: "number",
            default: 1,
            description: $t(
              "edit_campaign.schema_ticket_free_price_amount_config_tickets_qty_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
        },
      },
    },
    custom_fields: {
      title: $t("edit_campaign.schema_ticket_free_price_custom_fields", "Custom fields"),
      type: "list",
      default: [],
      expanded: true,
      items: {
        type: "object",
        properties: {
          label: {
            title: $t("edit_campaign.schema_ticket_free_price_custom_fields_label", "Label"),
            type: "string",
            default: "",
            description: $t(
              "edit_campaign.schema_ticket_free_price_custom_fields_label_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
          name: {
            title: $t("edit_campaign.schema_ticket_free_price_custom_fields_name", "Name"),
            type: "string",
            default: "",
            description: $t(
              "edit_campaign.schema_ticket_free_price_custom_fields_name_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
          type: {
            title: $t("edit_campaign.schema_ticket_free_price_custom_fields_type", "Type"),
            type: "enum",
            default: "text",
            extended: true,
            items: {
              title: "",
              type: "enum",
              default: "",
              enum: [
                {
                  text: $t(
                    "edit_campaign.schema_ticket_free_price_custom_fields_type_text",
                    "Text"
                  ),
                  value: "text",
                },
                {
                  text: $t(
                    "edit_campaign.schema_ticket_free_price_custom_fields_type_number",
                    "Number"
                  ),
                  value: "number",
                },
                {
                  text: $t(
                    "edit_campaign.schema_ticket_free_price_custom_fields_type_checkbox",
                    "Checkbox"
                  ),
                  value: "checkbox",
                },
                {
                  text: $t(
                    "edit_campaign.schema_ticket_free_price_custom_fields_type_date",
                    "Date"
                  ),
                  value: "date",
                },
                {
                  text: $t("edit_campaign.schema_ticket_free_price_custom_fields_type_ddl", "DDL"),
                  value: "ddl",
                },
                {
                  text: $t(
                    "edit_campaign.schema_ticket_free_price_custom_fields_type_multiselect",
                    "Multiselect"
                  ),
                  value: "multiselect",
                },
                {
                  text: $t(
                    "edit_campaign.schema_ticket_free_price_custom_fields_type_jewish_date",
                    "Jewish date"
                  ),
                  value: "jewish-date",
                },
                {
                  text: $t(
                    "edit_campaign.schema_ticket_free_price_custom_fields_type_greg_date",
                    "Greg date"
                  ),
                  value: "greg-date",
                },
              ],
            },
          },
          required: {
            title: $t("edit_campaign.schema_ticket_free_price_custom_fields_required", "Required"),
            type: "boolean",
            default: "false",
            description: $t(
              "edit_campaign.schema_ticket_free_price_custom_fields_required_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
          order: {
            title: $t("edit_campaign.schema_ticket_free_price_custom_fields_order", "Order"),
            type: "number",
            description: $t(
              "edit_campaign.schema_ticket_free_price_custom_fields_order_description",
              {
                returnEmptyOnMissing: true,
              }
            ),
          },
        },
      },
    },
    gender: {
      title: $t("edit_campaign.schema_ticket_free_price_gender", "Gender"),
      type: "object",
      properties: {
        show: {
          title: $t("edit_campaign.schema_ticket_free_price_gender_show", "Show"),
          type: "boolean",
          default: false,
          description: $t("edit_campaign.schema_ticket_free_price_gender_show_description", {
            returnEmptyOnMissing: true,
          }),
        },
        required: {
          title: $t("edit_campaign.schema_ticket_free_price_gender_required", "Required"),
          type: "boolean",
          default: false,
          description: $t("edit_campaign.schema_ticket_free_price_gender_required_description", {
            returnEmptyOnMissing: true,
          }),
        },
      },
    },
    image_step: {
      title: $t("edit_campaign.schema_ticket_free_price_image_step", "Image step"),
      type: "object",
      properties: {
        value: {
          title: $t("edit_campaign.schema_ticket_free_price_image_step_value", "Active"),
          type: "boolean",
          default: false,
          description: $t("edit_campaign.schema_ticket_free_price_image_step_value_description", {
            returnEmptyOnMissing: true,
          }),
        },
        image_src: {
          title: $t("edit_campaign.schema_ticket_free_price_image_step_image_src", "Image url"),
          type: "string",
          default: "",
          description: $t(
            "edit_campaign.schema_ticket_free_price_image_step_image_src_description",
            {
              returnEmptyOnMissing: true,
            }
          ),
        },
      },
    },
    exclude_trgets: {
      title: $t(
        "edit_campaign.schema_ticket_free_price_exclude_trgets",
        "Exclude targets (raffle-ticket, main, team, level)"
      ),
      type: "array",
      expanded: true,
      default: [],
      description: $t("edit_campaign.schema_ticket_free_price_exclude_trgets_description", {
        returnEmptyOnMissing: true,
      }),
      items: {
        title: "Items",
        type: "string",
        default: "",
      },
    },
    as_an_additional_button: {
      title: $t(
        "edit_campaign.schema_ticket_free_price_as_an_additional_button",
        "As an additional button"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_ticket_free_price_as_an_additional_button_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
    after_donation: {
      title: $t("edit_campaign.schema_ticket_free_price_after_donation", "After donation"),
      type: "boolean",
      default: false,
      description: $t("edit_campaign.schema_ticket_free_price_after_donation_description", {
        returnEmptyOnMissing: true,
      }),
    },
    submit_letter_with_no_donation: {
      title: $t(
        "edit_campaign.schema_ticket_free_price_submit_letter_with_no_donation",
        "Submit letter with no donation"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_ticket_free_price_submit_letter_with_no_donation_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
    total_not_multiply_to_num_of_tikets: {
      title: $t(
        "edit_campaign.schema_ticket_free_price_total_not_multiply_to_num_of_tikets",
        "Total not multiply to num of tikets"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_ticket_free_price_total_not_multiply_to_num_of_tikets_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
    allow_to_add_extra_amount: {
      title: $t(
        "edit_campaign.schema_ticket_free_price_allow_to_add_extra_amount",
        "Allow to add extra amount"
      ),
      type: "boolean",
      default: false,
      description: $t(
        "edit_campaign.schema_ticket_free_price_allow_to_add_extra_amount_description",
        {
          returnEmptyOnMissing: true,
        }
      ),
    },
  },
});
